import App from 'controllers/App';
import utils from 'utils';
import store from 'utils/store';
import resize from 'utils/resize';
import lazyLoadSetup from 'utils/lazyLoad';
import { fetchCurrentSession } from 'actions/session';
import { getAgeRangeDefaults } from 'actions/bookingWidget';
import { Iterable } from 'immutable';
import { setAppConfig } from '@ehi/global-marketing-interface/setAppConfig';
import { getVehiclesList } from 'actions/vehicles';
import { getInPathVehicleUpgradeDetails } from 'actions/reservation/getInPathVehicleUpgradeDetails';
import { RESERVATIONS } from 'constants';
import { ClearLocalStorageKeyStartsWith } from 'utils/localStorage';

const GMI_CONFIG = utils.config.getGMIConfig();

const isDeepLinkPage = () =>
  window.ehi.aem.page_info.site_section === 'deeplink' ||
  window.ehi.aem.page_info.site_section === 'universal-deeplink';

// Connect App
function initApp() {
  lazyLoadSetup();
  if (!isDeepLinkPage()) {
    // Making current API call, only after the Vehicle Rates api is completed. This Change is only for review Page
    // As we wanted to get analytics page view call before the current call. because whenever the current call happens, the PageView call gets fired for the updated session
    if (utils.isInResFlowReviewPage()) {
      store.dispatch(getInPathVehicleUpgradeDetails()).then(() => {
        store.dispatch(fetchCurrentSession({ enteredThroughSpa: true }));
      });
    } else {
      store.dispatch(fetchCurrentSession({ enteredThroughSpa: true }));
    }
  }

  resize.init(store);
  // get default age range options
  store.dispatch(getAgeRangeDefaults(GMI_CONFIG.COUNTRY));

  // Get vehicles list
  const getCountryCodeFromSessionStorage = JSON.parse(sessionStorage.getItem(RESERVATIONS.VEHICLES_INIT_LOCALSTORAGE));

  // clearing old session timer data from localstorage
  ClearLocalStorageKeyStartsWith('sessionDeadlineValue');
  ClearLocalStorageKeyStartsWith('pauseTimer');

  if (getCountryCodeFromSessionStorage) {
    const country_code = Object.keys(getCountryCodeFromSessionStorage);
    store.dispatch(getVehiclesList(country_code?.[0]));
  }
  utils.accessibility.a11yFocusOutline();
  window.getState = (statePath) => {
    const state = store.getState().getIn(statePath);
    return Iterable.isIterable(state) ? utils.safeToJS(state) : state;
  };
  const countryCode = utils.localization.getAkamaiCountryCode();
  const existingGmaHeaders = utils.config.getGMIConfig()?.GMA_HEADERS || {};
  setAppConfig({
    GMA_HEADERS: { ...existingGmaHeaders, cdn_country_of_residence: countryCode },
  });
  App.init(store, document);
}

// Initiate the app once the dom is ready
utils.dom.domReady(initApp);
